import { useEffect, useState } from "react";
import { useAppSelector } from "../../../store";
import { storedLocale } from "../../Authentication/util";
import { useGetNbbvQuery } from "../../../services/ActionReports/ActionReportAPI";
import type { NbbvResponse } from "../../../services/ActionReports/ActionReportAPI.types";
import { useWatchlistFetch } from "../hooks/useWatchlistFetch";

export const defaultNbbvActionReportData = (): NbbvResponse => {
  return {
    downlineCounts: 0,
    downlines: [],
  };
};

export const FetchNbbvActionReportData = (period: string, skipRequest = false) => {
  const { user } = useAppSelector((state) => state.boot);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetNbbvQuery(
    {
      Aff: user.aff,
      Abo: user.abo,
      Period: period,
      Locale: storedLocale(),
    },
    {
      skip: skipRequest,
    },
  );

  const { isLoading: isLoadingWatchlist } = useWatchlistFetch();

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [nbbvData, setNbbvData] = useState<NbbvResponse>(defaultNbbvActionReportData());

  useEffect(() => {
    setIsLoading(isFetching || isLoadingWatchlist);
    setErrorStatus(isError);

    if (!isFetching && !isError && payloadData) {
      setNbbvData(payloadData);
    }
  }, [isFetching, period, isError, payloadData, isLoadingWatchlist]);

  return { isLoading, nbbvData, errorStatus, refetch };
};
